<template>
  <circle-statistic
    icon="shopping_basket"
    :title="$t('customs.dashboard.averageBasket')"
    :sub-title="subtitle"
    :value="periodDiffPositiveValue"
    :text="formatPrice(averageBasket, currency)"
    :color="color"
    :caption="
      periodDiffIsInfinity
        ? ''
        : $t('customs.dashboard.previousPeriod') + ' ' + formatPrice(averageBasketPrevious, currency)
    "
    :is-negative="Math.sign(percentagePeriodDiff) !== 1"
    :loading="loading"
  >
  </circle-statistic>
</template>

<script>
  import { Helpers } from '../../mixins/Helpers.js'
  import CircleStatistic from '@/components/Widgets/statistic/CircleStatistic'
  export default {
    name: 'AverageBasketIndicator',
    mixins: [Helpers],
    components: {
      CircleStatistic
    },
    props: {
      sales: Array,
      previousSales: Array,
      loading: Boolean,
      averageBasket: Number,
      averageBasketPrevious: Number,
      currency: String
    },
    computed: {
      percentagePeriodDiff() {
        let diff = ((this.averageBasket - this.averageBasketPrevious) / this.averageBasketPrevious) * 100
        if (!isNaN(diff)) {
          return Math.round(diff)
        } else {
          return 0
        }
      },
      periodDiffPositiveValue() {
        let diff = this.percentagePeriodDiff
        if (diff < 0) {
          return -diff
        } else {
          return diff
        }
      },
      subtitle() {
        return this.percentagePeriodDiff === Infinity
          ? this.$t('customs.dashboard.unavailableDataForPreviousPeriod')
          : this.percentagePeriodDiff + '% ' + this.$t('customs.dashboard.vsPreviousPeriod')
      },
      periodDiffIsInfinity() {
        return this.percentagePeriodDiff === Infinity
      },
      color() {
        if (Math.sign(this.percentagePeriodDiff) === 1) {
          return 'green'
        } else if (Math.sign(this.percentagePeriodDiff) === -1) {
          return 'red'
        } else {
          return 'primary'
        }
      }
    }
  }
</script>

<style scoped></style>
